import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@auth/services/authentication.service';
import { RbsService } from '@auth/services/rbs.service';
import { catchError, iif, map, of, switchMap, tap } from 'rxjs';

export const hasRoleListGuard: CanActivateFn = () => {
  const rbsService = inject(RbsService);
  const authenticationService = inject(AuthenticationService);

  const logout$ = authenticationService.logout().pipe(map(() => false));

  return rbsService.fetchUserOrganizationList().pipe(
    switchMap(userOrganizationList => iif(() => userOrganizationList.length > 0, of(true), logout$)),
    tap(() => rbsService.verifyStoredUserOrganization()),
    catchError(() => logout$)
  );
};
